// src/components/WaveHeader.jsx
import React from 'react';

export default function WaveHeader({ className = "" }) {
  return (
    <div className={`absolute bottom-0 left-0 w-full overflow-hidden ${className}`} style={{ height: '120px' }}>
      <svg
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        <path
          d="M0,96L48,90.7C96,85,192,75,288,80C384,85,480,107,576,106.7C672,107,768,85,864,74.7C960,64,1056,64,1152,74.7C1248,85,1344,107,1392,117.3L1440,128L1440,140L1392,140C1344,140,1248,140,1152,140C1056,140,960,140,864,140C768,140,672,140,576,140C480,140,384,140,288,140C192,140,96,140,48,140L0,140Z"
          fill="currentColor"
          className="transition-colors duration-500"
          style={{
            animation: 'waveFloat 4s ease-in-out infinite',
          }}
        ></path>
      </svg>

      {/* Стили для анимации — встраиваем прямо в компонент */}
      <style jsx>{`
        @keyframes waveFloat {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
        }
      `}</style>
    </div>
  );
}